window.addEventListener("load", function() {
    if (typeof AOS === "undefined") return;
    AOS.init({
        once: true
    });
});

//# sourceMappingURL=repo.601601c2.js.map
